import {
    FETCH_REGULAR_BILLING_HISTORY_REQUEST,
    FETCH_REGULAR_BILLING_HISTORY_SUCCESS,
    FETCH_REGULAR_BILLING_HISTORY_FAILED,
    FETCH_REGULAR_BILLING_INFO_REQUEST,
    FETCH_REGULAR_BILLING_INFO_SUCCESS,
    FETCH_REGULAR_BILLING_INFO_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_REGULAR_BILLING_HISTORY_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_REGULAR_BILLING_HISTORY_SUCCESS]: (state, { status, data }) => {
        state.status = status
        state.history = data
    },
    [FETCH_REGULAR_BILLING_HISTORY_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_REGULAR_BILLING_INFO_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_REGULAR_BILLING_INFO_SUCCESS]: (state, { status, data }) => {
        state.status = status
        state.allatkey = data
    },
    [FETCH_REGULAR_BILLING_INFO_FAILED]: (state, error) => {
        state.status = 'error'
    }
}

export default mutations
